import { Icon, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import UseTranslation from '../../../hooks/UseTranslation'

const InfoBox = ({ number, color, subtitle, icon, customStyle }) => {
  const { t } = UseTranslation()
  return (
    <Box sx={[styles.boxStyle, customStyle && customStyle]}>

      {icon && (
        <Box sx={[styles.iconContainer, { backgroundColor: `${color}15` }]}>
          <Icon sx={[styles.iconStyle, { color: `${color}` }]}>{icon}</Icon>
        </Box>
      )}
      <Box sx={styles.info}>
        <Typography variant="body1" sx={[styles.numberStyle, { color: `${color}` }]}>
          {number}
          <Typography variant="p" sx={styles.unitUser}>
            {`${t?.Users}`}
          </Typography>
        </Typography>
        <Box sx={styles.subtitleStyle}>{subtitle}</Box>
      </Box>
    </Box>
  )
}

const styles = {
  boxStyle: {
    boxSizing: 'border-box',
    maxWidth: { xs: 'auto', sm: '442px' },
    width: '100%',
    height: { xs: '72px', sm: '110px' },
    border: '1px solid #ECEDF1',
    borderRadius: '15px',
    padding: { xs: '10px 8px', sm: '16px' },
    backgroundColor: '#fff',
    margin: { xs: '8px 0', sm: '8px 0px' },
    display: 'flex',
    alignItems: 'center',
  },
  iconContainer: {
    borderRadius: { xs: '50%', sm: '30px' },
    width: { xs: '43px', sm: '80px' },
    height: { xs: '43px', sm: '80px' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: { xs: '3px', sm: 'unset' },
    '& span': {
      width: { xs: '21px', sm: '40px' },
      height: { xs: '25px', sm: '40px' },
    },
  },
  iconStyle: {
    '& img': {
      width: { xs: '22px', sm: '40px' },
      height: { xs: '25px', sm: '40px' },
    },
  },
  info: {
    marginLeft: { xs: '0px', md: '16px' },
  },
  numberStyle: {
    fontFamily: 'Avenir 85 light',
    fontWeight: 800,
    fontSize: { xs: '16px', sm: '28px' },
    lineHeight: { xs: '30px', sm: '43px' },
  },
  unitUser: {
    marginLeft: '8px',
    fontFamily: 'Avenir 85 light',
    fontWeight: 800,
    fontSize: { xs: '14px', sm: '18px' },
    lineHeight: { xs: '20px', sm: '28px' },
    color: '#000',
  },
  subtitleStyle: {
    fontFamily: 'Avenir 85 light',
    fontWeight: 500,
    fontSize: { xs: '9px', sm: '14px' },
    lineHeight: { xs: '16px', sm: '21px' },
    color: '#B4B4B9',
  },
};
export default InfoBox;
